import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import WorkplanView from "./WorkplanView"

export class Workplan extends Component {
  static propTypes = {
    workplan: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props)
  
    this.state = {
       //projectLoaded:false
    }
  }
  UNSAFE_componentWillMount(){
    if(this.props.project){
      this.props.actions.getWorkplan(this.props.project)
    }
  }
  render() {
    return (
      <WorkplanView
      fetchData={this.props.workplan.fetchData} 
      setLoading={this.props.actions.setLoading}
      loading={this.props.workplan.loading}
      />
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    workplan: state.workplan,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Workplan);



// WEBPACK FOOTER //
// ./src/features/workplan/Workplan.js